<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Tracking Dashboard </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <!-- <li class="breadcrumb-item"><router-link to='/mydashboard'> Dashboard</router-link>
                                </li> -->
                                
                               
                                
                            </ol>
                        </div>
                        
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="content-body">
               
                <section>
                     <div class="card">
                      
                        <div class="card-header px-0  common_top_title_searchbgst_dock">
                            <div class="container-fluid " >
                                <div class="row row fc_my-05">
                                    <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                            <div class="avatar-content">
                                                <i  class="i_icon_st la-chalkboard-teacher las lab font-medium-5 "></i>
                                            </div>
                                        </div>
                                        <h4 class="card-title d-inline-flex ml-0 mb-0"> Tracking Dashboard</h4>
                                    </div>
                                   
                                </div>    
                                    
                            </div>
                        </div>
                      
                      
                            <div class="card text-center mb-1 p-1 p-md-2">
                                <div class="row match-height gateperformanceiconTrakingdb">
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-15 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 22 Min.</span>
                                                </div>
                                                <h2 class="font-weight-bolder">vehicle avg idle time </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-16 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 11 Min.</span>
                                                </div>
                                                <h2 class="font-weight-bolder">vehicle avg wait time </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-17 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 2 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Vehicle delayed numbers / daily   </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-18 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 14 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Vehicle delayed numbers / weekly  </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-19 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 4 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">On Dock Delays  </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-20 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 3 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">On Gate Dalays  </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-07 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> {{dataPoints.accident_count}}</span>
                                                </div>
                                                <h2 class="font-weight-bolder">Accident Total numbers </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-08 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> {{dataPoints.breakdown_count}}</span>
                                                </div>
                                                <h2 class="font-weight-bolder">Breakdown total numbers</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-09 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 473 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Total Routes numbers </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-10 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 200 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Total MultiTocuh Point Route</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-11 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 273 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Total direct Route </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-12 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 5,901 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Total Distance ( KM ) Daily</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5" >
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-13 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../public/images/icons/truck-1.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview"> 35,000 </span>
                                                </div>
                                                <h2 class="font-weight-bolder">Total Distance ( KM ) weekly </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                     </div>
                </section>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../constants.js"
import { read, utils } from "xlsx";
import schema from "../utils/schema";
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default({
    name:'trackingDashboard',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        Pagination,
    },
    data() {
        return {
            un:'',
            isLoading: false,
            isShipmentsSyncing: false,
            isMasterListLoading: true,
            pagefeatures:[],
            isFormEdit: false,
            warehouse_master: false,  

            master: {
               
                warehouse_master: {
                    url: "/master/warehouses",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },

             
            },
            dataPoints: {
                accident_count: 0,
                breakdown_count: 0
            },
         
            photoCaptureSound: 'sound/iphone-camera-capture-6448.wav',
        }  
    } ,
    mounted(){
      
        this.getTrackingDashboardCounts()

        
    },
    methods: {
       
     
        toggleMasterCreate() {
            if(this.isFormEdit) {
                this.resetform('warehouse_master')
            }
            this.isFormEdit = false
            this.warehouse_master = !this.warehouse_master; 
        },

        getTrackingDashboardCounts() {
            this.isLoading = true
            this.makeRequest("POST", "/stats/trakingdashboard-data-points")
                .then(result => {
                    this.isLoading = false
                    this.dataPoints = result.data.data
                })
                .catch(e => {
                    this.displayError(e)
                })
        }

    }
})
</script>
<style scoped>
    .alignment{
        margin-left: 20px;
        margin-bottom: 20px;
    }
    .requiredField {
        margin-left: 2px;
        color: red
    }
    #overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    
    .overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    </style>